"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scanChildren = scanChildren;
function scanChildren(nodes) {
    const groups = [];
    let atomBuffer = [];
    let atomStartIndex = 0;
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node.type === 'atom') {
            if (atomBuffer.length === 0) {
                atomStartIndex = i;
            }
            atomBuffer.push(node.content);
        }
        else {
            groups.push({
                atoms: atomBuffer,
                atomStartIndex: atomBuffer.length === 0 ? i : atomStartIndex,
                node: node,
                payloadIndex: i,
            });
            atomBuffer = [];
        }
    }
    return {
        groups,
        trailingAtoms: atomBuffer,
        trailingStartIndex: atomBuffer.length > 0 ? atomStartIndex : -1,
    };
}
//# sourceMappingURL=scanner.js.map